import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { OutlinedIcons } from '@marageti/z4-lib';

const { OutlinedChatIcon } = OutlinedIcons;

type SendMessageButtonProps = {
  tripRequestId?: string;
  messageLink: string;
};

const SendMessageButton = ({
  tripRequestId,
  messageLink,
}: SendMessageButtonProps) => {
  const navigate = useNavigate();

  return (
    <Tooltip
      title={
        tripRequestId
          ? 'Send Message'
          : 'This reminder is not related to a Trip Request'
      }
    >
      <span>
        <IconButton
          color="primary"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            e.preventDefault();
            navigate(messageLink);
          }}
          disabled={!tripRequestId}
        >
          <OutlinedChatIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default SendMessageButton;
